import React from 'react';
import ReactDOM from 'react-dom';

import AnnotatorApp from '../../components/Annotator/AnnotatorApp';
import Annotation from '../../components/Annotator/Annotation';
import DeleteConfirmation from '../../components/Annotator/components/DeleteConfirmation';
import {
  annotationCreated,
  annotationDeleted,
  annotationUpdated,
  closeAnnotator,
} from './actions';
import { getElementPosition } from './utils';


export const canBeAnnotated = quote => {
  const HAS_NON_WHITESPACE_CHARACTER_REGEX = /\S/;
  return HAS_NON_WHITESPACE_CHARACTER_REGEX.test(quote);
}

export const AnnotatorContainer = (app, uuid, gocheckVersion) => {
  return (viewer) => {
    viewer.addField({
      load: (field, { error_type: errorType, quote, type, isDelete, ...restAnnotation }) => {
        if (!canBeAnnotated(quote)) {
          setImmediate(() => viewer.hide());
          return;
        }

        const annotation = { errorType, quote, ...restAnnotation };
        const closeEvent = () => closeAnnotator(app, field);
        if (isDelete) {
          ReactDOM.render(
            <DeleteConfirmation
              type={type}
              onDelete={() => {
                annotationDeleted(app, uuid, annotation, type)
                closeEvent()
              }}
              onCancel={closeEvent}
            />,
            field,
          );
          return;
        }

        ReactDOM.render(
          <AnnotatorApp
            gocheckVersion={gocheckVersion}
            annotation={annotation}
            onAnnotationCreate={(annotation, type) => annotationCreated(app, uuid, annotation, type)}
            onAnnotationUpdate={(annotation, type) => annotationUpdated(app, uuid, annotation, type)}
            onClose={closeEvent}
            type={type}
          />,
          field,
        );
      },
      submit: {},  // Override the submit function so the submit process in the lib will not proceed
    });
  }
}

export const renderAnnotator = (app, viewer, annotation, isDelete) => {
  const viewerPosition = getElementPosition(viewer.element[0]);
  app.runHook('setInteractionPoint', [viewerPosition]);
  viewer.hide();
  app.runHook('beforeAnnotationUpdated', [{
    ...annotation,
    isDelete,
  }]);
};

export const AnnotationContainer = (app, uuid, gocheckVersion, isEditable) => {
  return (viewer) => {
    viewer.addField({
      load: (field, annotation) => {
        const { error_type, severity, comment, type } = annotation;
        ReactDOM.render(
          <Annotation
            severity={severity}
            errorType={error_type}
            comment={comment}
            gocheckVersion={gocheckVersion}
            isEditable={isEditable}
            type={type}
            onDelete={() => renderAnnotator(app, viewer, annotation, true)}
            onEdit={() => renderAnnotator(app, viewer, annotation, false)}
          />,
          field,
        )
        app.runHook('annotationModalOpened');
      }
    });
  };
}
